import { useQuery } from 'react-query';

import { getPayementInfoRoute, paymentDetails } from '@features/payments';
import axiosInstance from '@server/axiosInstance';

type useGetPaymantDetailsProps = {
  companyId?: number | string;
};
export const useGetPaymantDetails = ({ companyId }: useGetPaymantDetailsProps = {}) => {
  const { data: paymentInfo, isLoading: isPaymentInfoLoading } = useQuery({
    queryKey: [paymentDetails, companyId],
    queryFn: () =>
      axiosInstance
        .get(`${getPayementInfoRoute}${companyId ? `?company_id=${companyId}` : ''}`)
        .then((res) => res.data),
    refetchOnWindowFocus: false,
  });

  return {
    paymentInfo,
    isPaymentInfoLoading,
  };
};
